import "../styles/plan-selection.scss";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { Context } from "../context/AuthContext";
import { UserState } from "../appState";
import { Check } from "@mui/icons-material";
import logo from "../assets/img/FFF_Logo_Orange_Horizontal.png";
import ProtectedRoute from "../components/guards/protected-route";

const orderApiUrl = `${process.env.REACT_APP_API_URL}/api/orders`;

const PlanSelection = () => {
  const navigate = useNavigate();
  const user = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleStartTrial = async () => {
    setLoading(true);
    setErrorMsg("");
    try {
      const priceId = "price_1QajpXGL1dDBQUpkYNpXIcNR"; // Pro Nationwide
      const UserToken = localStorage.getItem("ffftoken");
      const UID = UserState.getState().uid || "";

      const res = await fetch(`${orderApiUrl}/createCheckoutSession`, {
        method: "POST",
        headers: new Headers({
          "content-type": "application/json",
          "authorization": `${UserToken}`,
          "x-user-id": UID,
        }),
        body: JSON.stringify({
          priceId,
          user: UserState?.getState()?.uid,
          email: UserState?.getState()?.email,
        }),
      });

      if (res.status === 200) {
        const data = await res.json();
        if (data?.data) {
          window.location.href = data.data;
          return;
        }
      } else {
        setErrorMsg("Something went wrong. Please try again.");
      }
    } catch (err: any) {
      setErrorMsg(err?.message || "An error occurred");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSignOut = async () => {
    const auth = getAuth();
    try {
      await signOut(auth);
      navigate("/");
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <ProtectedRoute>
      <div className="plan-selection-page">
        <div className="plan-selection-content">
          <div className="plan-selection-header">
            <img src={logo} alt="FlyFishFinder" className="plan-logo" />
          </div>

          <div className="plan-selection-body">
            <h1 className="plan-title">Start Your 14-Day Free Trial</h1>
            <p className="plan-subtitle">
              Get full access to FlyFishFinder Pro. No charge today — cancel anytime during your trial.
            </p>

            <div className="plan-card active">
              <div className="plan-card-header">
                <div className="plan-card-badge">MOST POPULAR</div>
                <h2 className="plan-card-name">Pro Nationwide</h2>
                <div className="plan-card-pricing">
                  <span className="plan-price-free">FREE</span>
                  <span className="plan-price-duration">for 14 days</span>
                </div>
                <p className="plan-price-after">
                  Then <s>$49.99</s> <strong>$29.99</strong>/year
                </p>
              </div>

              <div className="plan-card-features">
                <div className="plan-feature">
                  <span className="plan-check"><Check /></span>
                  <span>Access maps across all 50 states — 220,000+ rivers</span>
                </div>
                <div className="plan-feature">
                  <span className="plan-check"><Check /></span>
                  <span>Real access insights — wade spots, easements, floatable water</span>
                </div>
                <div className="plan-feature">
                  <span className="plan-check"><Check /></span>
                  <span>Real-time flows &amp; stream conditions</span>
                </div>
                <div className="plan-feature">
                  <span className="plan-check"><Check /></span>
                  <span>Connect with the community and local guides</span>
                </div>
                <div className="plan-feature">
                  <span className="plan-check"><Check /></span>
                  <span>Save spots &amp; build personal trip plans</span>
                </div>
              </div>

              <button
                className="primary fill hover-shadow plan-start-btn"
                onClick={handleStartTrial}
                disabled={loading}
              >
                {loading ? "Loading..." : "Start Free Trial — $0 Today"}
              </button>

              {!!errorMsg && <p className="plan-error">{errorMsg}</p>}

              <p className="plan-disclaimer">
                You will not be charged during your 14-day trial. Cancel anytime — no questions asked.
              </p>
            </div>
          </div>

          <div className="plan-selection-footer">
            <button className="plan-logout-btn" onClick={handleSignOut}>
              Log Out
            </button>
          </div>
        </div>
      </div>
    </ProtectedRoute>
  );
};

export default PlanSelection;
